import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ChevronRight } from 'lucide-react-native';
import { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';

/** 查看完整对话, at the foot of the report. */
export const TranscriptLink = memo(({ onPress }: { onPress: () => void }) => {
  const { rpx } = useResponsiveContext();
  return (
    <TouchableOpacity
      accessibilityRole="link"
      onPress={onPress}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: rpx(2),
        paddingVertical: rpx(8),
      }}
    >
      <Typography.Text size={rpx(12)} bold color={aiColors.primary}>
        查看完整对话
      </Typography.Text>
      <ChevronRight size={rpx(14)} color={aiColors.primary} />
    </TouchableOpacity>
  );
});
